<template>
  <div>
    <div v-if="loading">
      <amenity-manatee-loading></amenity-manatee-loading>
    </div>
    <div v-else>
      <div class="panel panel-default" style="border: 1px solid #ccc; background-color: white">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a href="javascript://void(0)" @click="toggleShowAll">
              <i v-if="collapseSection" class="fa fa-angle-right" aria-hidden="true"></i>
              <i v-else class="fa fa-angle-down" aria-hidden="true"></i>
              {{ this.packagePrice.Name }}
              <h6>{{ this.packagePrice.InternalDescription }}</h6>
            </a>
          </h4>

        </div>
        <div class="panel-collapse" :class="{ collapse: this.collapseSection }" style="background-color: white">
          <div class="panel-body" style="background-color: white">
            <ul class="list-group">
              <li class="list-group-item">
                <div class="form-group">
                  <div class="row form-group">
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Line Item Description</dt>
                        <dd>
                          {{ this.packagePrice.LineItemName }}
                        </dd>
                      </dl>
                    </div>
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>GL Code</dt>
                        <dd>
                          {{ this.packagePrice.GLCode }}
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Package Price Type</dt>
                        <dd>
                          {{ this.packagePrice.PackagePriceType }}
                        </dd>
                      </dl>
                    </div>
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Starting Amount</dt>
                        <dd>
                          ${{ this.packagePrice.StartingAmount }}
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Billing Start Date</dt>
                        <dd>
                          {{ $options.filters.date(this.packagePrice.BillingStartDate) }}
                        </dd>
                      </dl>
                    </div>
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Billing Interval Frequency</dt>
                        <dd>
                          {{ this.packagePrice.BillingIntervalFrequency }}
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>First Price Increase Start Date</dt>
                        <dd>
                          {{ $options.filters.date(this.packagePrice.FirstPriceIncreaseStartDate) }}
                        </dd>
                      </dl>
                    </div>
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Price Increase Interval Frequency</dt>
                        <dd>
                          {{ this.packagePrice.PriceIncreaseIntervalFrequency }}
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Price Increase Percentage</dt>
                        <dd>
                          {{ this.packagePrice.PriceIncreasePercentage }}%
                        </dd>
                      </dl>
                    </div>
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Record Id</dt>
                        <dd>
                          {{ this.packagePrice.Id }}
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-sm-12 text-right">
                      <button type="button" class="btn btn-primary" id="open-modal" @click="openModal">
                        Edit
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <legend>Price Intervals</legend>
            <div class="row">
              <div class="col-xs-6 form-group"></div>
              <div class="col-xs-6 form-group text-right">
                <div class="input-group">
                  <label for="include-withdrawn-withdrawnox">Include Withdrawn & Rejected </label>
                  <input type="checkbox" id="include-withdrawn" v-model="includeWithdrawn" />
                </div>
              </div>
            </div>
            <div v-for="priceInterval in this.packagePrice.PriceIntervals" :key="priceInterval.Id">
              <div
                v-if="(priceInterval.PriceIntervalStatusId !== 5 && priceInterval.PriceIntervalStatusId !== 6) || includeWithdrawn">
                <core-price-interval :price_interval_id="priceInterval.Id" :show_community=false
                  :price_interval="priceInterval"></core-price-interval>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-xs-12 form-group text-right">
                <button type="button" class="btn btn-success" @click="addPriceInterval" :disabled="loading">
                  Add Price Interval
                </button>
              </div>
            </div>

            <div v-if="this.packagePrice.BillingRampPeriodIds.length > 0">

              <legend>Billing Ramp Periods</legend>
              <table class="table table-responsive table-striped table-hover table-bordered"
                style="table-layout: fixed; width: 100%">
                <thead>
                  <tr>
                    <th>
                      Interval
                    </th>
                    <th>
                      Percentage
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="billingRampPeriod in this.packagePrice.BillingRampPeriods" :key="billingRampPeriod.Id">
                    <td>{{ billingRampPeriod.SequenceNumber }}</td>
                    <td>{{ billingRampPeriod.Percentage }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <modal :name="modalName" :adaptive="true" :scrollable="true" height="auto" style="padding: 3rem 0 6rem 0">
        <form @submit.prevent="save" method="POST" accept-charset="UTF-8" class="margin-md-top"
          enctype="multipart/form-data" novalidate="novalidate">
          <div class="dashboard-block" :class="{ loading: loading }">
            <header>
              <div class="row form-group">
                <div class="col-sm-8">
                  <h4>
                    <span>{{ this.packagePrice.Name }}</span>
                  </h4>
                  <h5>{{ this.packagePrice.PackagePriceType }}</h5>

                </div>

                <div class="col-sm-4 text-right">
                  <button type="button" class="btn btn-primary" id="close-modal" @click="closeModal">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </header>



            <div class="row">
              <div class="col-sm-6 form-group has-feedback" :class="{ 'has-error': errors.has('InternalDescription') }">
                <label for="InternalDescription">Internal Description</label>
                <div class="input-group">
                  <input id="InternalDescription" type="text" class="form-control"
                    v-model="packagePrice.InternalDescription" v-validate="'required'" name="InternalDescription" />
                  <span v-show="errors.has('InternalDescription')" class="help-block">
                    {{ errors.first("InternalDescription") }}
                  </span>
                </div>
              </div>
              <div class="col-sm-6 form-group has-feedback" :class="{ 'has-error': errors.has('LineItemName') }">
                <label for="LineItemName">Line Item Name</label>
                <div class="input-group">
                  <input id="LineItemName" type="text" class="form-control" v-model="packagePrice.LineItemName"
                    v-validate="'required'" name="LineItemName" />
                  <span v-show="errors.has('LineItemName')" class="help-block">
                    {{ errors.first("LineItemName") }}
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 form-group has-feedback" :class="{ 'has-error': errors.has('GLCode') }">
                <label for="GLCode">GL Code</label>
                <div class="input-group">
                  <input id="GLCode" type="text" class="form-control" v-model="packagePrice.GLCode"
                    v-validate="'required'" name="GLCode" />
                  <span v-show="errors.has('GLCode')" class="help-block">
                    {{ errors.first("GLCode") }}
                  </span>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-sm-6 form-group has-feedback" :class="{ 'has-error': errors.has('StartingAmount') }">
                <label for="starting-amount">Starting Amount</label>
                <div class="input-group">
                  <span class="input-group-addon">$</span>
                  <input id="price-starting" type="number" class="form-control" v-model="packagePrice.StartingAmount"
                    v-validate="'required|between:0,300'" name="StartingAmount" />
                  <span v-show="errors.has('StartingAmount')" class="help-block">
                    {{ errors.first("StartingAmount") }}
                  </span>
                </div>
              </div>
              <div class="col-sm-6 form-group has-feedback"
                :class="{ 'has-error': errors.has('PriceIncreasePercentage') }">
                <label for="PriceIncreasePercentage">Price Increase Percentage</label>
                <div class="input-group">

                  <input id="PriceIncreasePercentage" type="number" class="form-control"
                    v-model="packagePrice.PriceIncreasePercentage" v-validate="'required|between:0,100'"
                    name="PriceIncreasePercentage" />
                  <span class="input-group-addon">%</span>
                  <span v-show="errors.has('PriceIncreasePercentage')" class="help-block">
                    {{ errors.first("PriceIncreasePercentage") }}
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 form-group">
                <label for="BillingStartDate">Billing Start Date</label>

                <input id="BillingStartDate" type="date" class="form-control" v-model="packagePrice.BillingStartDate"
                  v-validate="'required'" name="BillingStartDate" />
                <span v-show="errors.has('BillingStartDate')" class="help-block">
                  {{ errors.first("BillingStartDate") }}
                </span>
              </div>
              <div class="col-sm-6 form-group">
                <label for="FirstPriceIncreaseStartDate">First Price Increase Start Date</label>

                <input id="FirstPriceIncreaseStartDate" type="date" class="form-control"
                  v-model="packagePrice.FirstPriceIncreaseStartDate" v-validate="'required'"
                  name="FirstPriceIncreaseStartDate" />
                <span v-show="errors.has('FirstPriceIncreaseStartDate')" class="help-block">
                  {{ errors.first("FirstPriceIncreaseStartDate") }}
                </span>
              </div>

            </div>

            <div class="row form-group">
              <div class="col-sm-6"></div>
              <div class="col-sm-6 text-right">
                <button type="button" class="btn btn-success" id="save-modal" @click="save"
                  :disabled="hasErrors || disableButtons">
                  Save
                </button>
              </div>
            </div>


            <span class="help-block">
              <ul>
                <li v-for="postError in this.postErrors" :key="postError">
                  {{ postError }}
                </li>
              </ul>
            </span>
          </div>
        </form>
      </modal>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    package_price_id: {
      required: true,
      type: String,
    },
  },
  mounted() {
    this.loadPackagePrice()
      .catch(this.$root.handleErrors)
      .finally(() => {
        if (this.packagePrice.PackagePriceType === "Resident->Community") {
          this.collapseSection = false;
        }
        this.loading = false;
      });
  },

  methods: {
    addPriceInterval() {
      this.loading = true;
      var url =
        "/core/packagePrice/" + this.package_price_id + "/newPriceInterval";
      axios.post(url).then((response) => {
        //console.error(response.data.PackagePrice);
        this.loadPackagePrice();
      });
    },
    toggleShowAll() {
      this.collapseSection = !this.collapseSection;
    },
    beforeLoad() {
      return this.loadPackagePrice();
    },
    openModal() {
      this.$modal.show(this.modalName);
    },
    closeModal() {
      this.$modal.hide(this.modalName);
    },
    loadPackagePrice() {
      var url = "/core/packagePrice/" + this.package_price_id;
      //console.log(url);
      return axios.get(url).then((response) => {
        //console.log(response.data.PackagePrice);
        this.$set(this, "packagePrice", response.data.PackagePrice);
        this.updateDates();

        this.loading = false;
      });
    },
    updateDates() {
      this.packagePrice.BillingStartDate = moment
        .utc(this.packagePrice.BillingStartDate)
        .format("YYYY-MM-DD");
      this.packagePrice.FirstPriceIncreaseStartDate = moment
        .utc(this.packagePrice.FirstPriceIncreaseStartDate)
        .format("YYYY-MM-DD");
    },
    save() {
      this.disableButtons = true;
      var url = "/core/packagePrice/" + this.packagePrice.Id;
      axios
        .post(url, {
          LineItemName: this.packagePrice.LineItemName,
          InternalDescription: this.packagePrice.InternalDescription,
          GLCode: this.packagePrice.GLCode,
          StartingAmount: this.packagePrice.StartingAmount,
          BillingStartDate: this.packagePrice.BillingStartDate,
          FirstPriceIncreaseStartDate: this.packagePrice.FirstPriceIncreaseStartDate,
          PriceIncreasePercentage: this.packagePrice.PriceIncreasePercentage,
        })
        .then((response) => {
          //console.error(response.data.PackagePrice);
          this.$notify({
            type: "success",
            placement: "top-left",
            title: "Saved Package Price Successfully",
          });
          this.closeModal();
          this.loading = true;
          this.loadPackagePrice();
        })
        .catch((error) => {
          if (error.response) {
            this.updatePostErrors(error.response.data.errors);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        })
        .finally(() => {
          this.disableButtons = false;
        });
    },
    updatePostErrors(errors) {
      console.log("updatePostErrors");
      console.log(errors);
      this.postErrors = errors;
    },
  },
  computed: {
    hasErrors() {
      return this.errors.any();
    },
    modalName() {
      return "editPackagePriceModal" + this.packagePrice.Id;
    },
  },
  data() {
    return {
      collapseSection: true,
      loading: true,
      packagePrice: null,
      disableButtons: false,
      postErrors: null,
      includeWithdrawn: false,
    };
  },

};
</script>